import React from 'react';
import urlBase from '../../url-base';
import {
    Container, Row, Col
} from 'reactstrap';
import MenuNew from '../MenuNew';
import Sidebar from '../Sidebar/MenuLeft';
import NavbarDrop from '../HomePageNew/NavbarDrop';
import Footer from '../HomePageNew/Footer';

import '../../assets/css/timeline.css';


class Page extends React.Component {


    render() {
        return (
            <div>
                <MenuNew />
                <NavbarDrop />

                <Container id="wallet_slip">
                    <div className="wallet_slip_img_inst">
                        <Row style={{ marginRight: 0 }}>
                            <Col style={{ marginTop: 90 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>

                            <Col id="wallet_slip_app_text" xs="12" sm="12" md="8" lg="8" xl="8">
                                <h1>HISTÓRIA</h1>
                            </Col>

                            <Col style={{ marginTop: 60 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>
                        </Row>
                    </div>


                </Container>

                <Container style={{ marginTop: -40 }}>
                    <Row style={{ marginRight: 0 }}>
                        <Col style={{ marginTop: 60, marginRight: 35 }} xs="12" sm="12" md="2" lg="2" xl="4">
                            <Sidebar />
                        </Col>
                        <Col style={{ marginTop: 60, margiLeft: 20 }} xs="12" sm="12" md="10" lg="10" xl="7">
                            <p className="text_footer text_red">ACREDITANDO EM SONHOS</p>
                            
                                
                            <ul style={{ marginTop: 30  }} className="css-1id2lqt">
                                <li className="css-1psltl0">
                                    {/* 1981 */}
                                    <img src={urlBase.client + 'assets/images2/1.png'} className='img_date'/>
                                    <div className="css-1tr4ugw">
                                        <div className="css-7mkrez">
                                            Dra. Edzenaide Raulino Martins concluí seu curso de odontologia, profissão escolhida por amor. 
                                            </div>
                                    </div>
                                </li>
                                <li className="css-1psltl0">
                                    {/* 1985 */}
                                    <img src={urlBase.client + 'assets/images2/2.png'} className='img_date' />
                                    <div className="css-1tr4ugw">                                        
                                        <div className="css-7mkrez">
                                            Trabalhou em clínicas particulares até que nasceu em seu coração um desejo: “Executar serviços e administrar Planos Odontológicos, atendendo às necessidades de sociabilização da saúde bucal, com qualidade, credibilidade, valores acessíveis e comprometimento de todos com a satisfação dos clientes”. 
                                        </div>
                                    </div>
                                </li>

                                <li className="css-1psltl0">
                                    {/* 1990 */}
                                    <img src={urlBase.client + 'assets/images2/3.png'} className='img_date' />
                                    <div className="css-1tr4ugw">

                                        <div className="css-7mkrez">
                                            Abertura da primeira clínica em sociedade com seu cônjuge, Marconi Martins da Silva. 1992 - Inauguração da sede e abertura da primeira filial. 
                                        </div>
                                    </div>
                                </li>

                                <li className="css-1psltl0">
                                    {/* 1992 */}
                                    <img src={urlBase.client + 'assets/images2/4.png'} className='img_date' />
                                    <div className="css-1tr4ugw">

                                        <div className="css-7mkrez">
                                            Inauguração da sede e abertura da primeira filial. 
                                        </div>
                                    </div>
                                </li>

                                <li className="css-1psltl0">
                                    {/* 2006 */}
                                    <img src={urlBase.client + 'assets/images2/5.png'} className='img_date' />
                                    <div className="css-1tr4ugw">

                                        <div className="css-7mkrez">
                                            Pioneira, a Dental Center passa a oferecer plano ortodôntico (com documentação inclusa) e tratamento fonoaudiológico gratuito. 
                                        </div>
                                    </div>
                                </li>

                                <li className="css-1psltl0">
                                    {/* 2010 */}
                                    <img src={urlBase.client + 'assets/images2/6.png'} className='img_date' />
                                    <div className="css-1tr4ugw">

                                        <div className="css-7mkrez">
                                            A Dental Center se torna, exclusivamente, uma operadora de planos odontológicos, desempenhando o seu melhor até os dias atuais. 
                                        </div>
                                    </div>
                                </li>

                                <li className="css-1psltl0">
                                    {/* 2014 */}
                                    <img src={urlBase.client + 'assets/images2/7.png'} className='img_date' />
                                    <div className="css-1tr4ugw">

                                        <div className="css-7mkrez">
                                            Renovação da linha de produtos e da estratégia de comercialização, agora com foco no varejo. 
                                        </div>
                                    </div>
                                </li>

                                <li className="css-1psltl0">
                                    {/* 2017 */}
                                    <img src={urlBase.client + 'assets/images2/8.png'} className='img_date' />
                                    <div className="css-1tr4ugw">

                                        <div className="css-7mkrez">
                                            Lançamento do Plano Dental Vip, o primeiro com carência de 1 minuto. 
                                        </div>
                                    </div>
                                </li>

                                <li className="css-1psltl0">
                                    {/* 2018 */}
                                    <img src={urlBase.client + 'assets/images2/9.png'} className='img_date' />
                                    <div className="css-1tr4ugw">

                                        <div className="css-7mkrez">
                                            Primeira operadora desenvolver apps para clientes e dentistas.
                                        </div>
                                    </div>
                                </li>

                                <li className="css-1psltl0">
                                    {/* 2019 */}
                                    <img src={urlBase.client + 'assets/images2/10.png'} className='img_date' />
                                    <div className="css-1tr4ugw">

                                        <div className="css-7mkrez">
                                            Primeira operadora paraibana implantar inteligência artificial para atendimento a usuários. Primeira operadora e desenvolver e implantar uma plataforma de vendas 100% digital. Realização do Primeiro Workshop de Estratégias de Vendas de Planos de Saúde
                                        </div>
                                    </div>
                                </li>
                            </ul>




                        </Col>
                    </Row>
                </Container>

                <Footer />
            </div>

        );
    }
}
export default Page;



/** WEBPACK FOOTER **
 ** ./src/components/Historia/Page.js
 **/